// set function parseTime,formatTime to filter
import i18n from "@/api/lang";
export { parseTime, formatTime } from '@/utils'


function pluralize(time, label) {
  if (time === 1) {
    return time + label
  }
  return time + label + 's'
}

export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time)
  if (between < 3600) {
    return pluralize(~~(between / 60), ' minute')
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), ' hour')
  } else {
    return pluralize(~~(between / 86400), ' day')
  }
}

/* 数字 格式化*/
export function numberFormatter(num, digits) {
  const si = [
    { value: 1E18, symbol: 'E' },
    { value: 1E15, symbol: 'P' },
    { value: 1E12, symbol: 'T' },
    { value: 1E9, symbol: 'G' },
    { value: 1E6, symbol: 'M' },
    { value: 1E3, symbol: 'k' }
  ]
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (num / si[i].value + 0.1).toFixed(digits).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
    }
  }
  return num.toString()
}

export function toThousandslsFilter(num) {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}



//终端功能文字拦截器
export function filterFuncs(val) {
  var label = i18n.t('constant.null');
  if (val) {
    let funcs = val.split(",");
    if (funcs.length > 0) {
      label = "";
      for (let temp of funcs) {
        label += i18n.t('constant.functs', { functs: temp });
      }
    }
    label = label.substring(0, label.length - 1);
  }
  return label;
}


//终端调度权限文字拦截器
export function filterOrganization(val) {
  var label = i18n.t('constant.null');
  if (val) {
    let funcs = val.split(",");
    if (funcs.length > 0) {
      label = "";
      for (let temp of funcs) {
        label += i18n.t('constant.organization', { organization: temp });
      }
    }
    label = label.substring(0, label.length - 1);
  }
  return label;
}

//巡更计划
export function filterPatrolWeek(val) {
  var label = i18n.t('constant.null');
  //alert(val);
  if (val) {
    let funcs = val.split(",");
    if (funcs.length > 0) {
      label = "";
      for (let temp of funcs) {
        label += i18n.t('constant.patrolWeek', { patrolWeek: temp });
      }
    }
    label = label.substring(0, label.length - 1);
  }
  return label;
}

export function filterTaskFunc(val) {
  var label = i18n.t('constant.null');
  if (val) {
    let funcs = val.split(",");
    if (funcs.length > 0) {
      label = "";
      for (let temp of funcs) {
        label += i18n.t('constant.taskFunc', { taskFunc: temp });
      }
    }
    label = label.substring(0, label.length - 1);
  }
  return label;
}


export function hierarchyConversion(val) {
  var label = i18n.t('constant.null');
  if(label == "Null"){
    var s = enHierarchyConversion(val);
    return s;
  }else {
    var s1 = zhHierarchyConversion(val);
    return s1;
  }

}

export function zhHierarchyConversion(val) {
  var label = i18n.t('constant.null');
  switch (val) {
    case 1:label = "一级";
      break;
    case 2:label = "二级";
      break;
    case 3:label = "三级";
      break;
    case 4:label = "四级";
      break;
    case 5:label = "五级";
      break;
    case 6:label = "六级";
      break;
    case 7:label = "七级";
      break;
    case 8:label = "八级";
      break;
    case 9:label = "九级";
      break;
    case 10:label = "十级";
      break;
    default:
      label = "";
  }
  return label;
}

export function enHierarchyConversion(val) {
  var label = i18n.t('constant.null');
  switch (val) {
    case 1:label = "First order";
      break;
    case 2:label = "Second stage ";
      break;
    case 3:label = "Third stage";
      break;
    case 4:label = "Fourth stage";
      break;
    case 5:label = "The first five";
      break;
    case 6:label = "The first level 6";
      break;
    case 7:label = "The seventh";
      break;
    case 8:label = "The first 8";
      break;
    case 9:label = "The ninth grade";
      break;
    case 10:label = "The tenth grade";
      break;
    default:
      label = "";
  }
  return label;
}



export function filterOnlien(val) {
  return i18n.t("constant.onlineStatus.map")[val];
}

export function filterStatus(val) {
  return i18n.t("constant.status.map")[val];
}

export function filterOrderFuncsByTable(row) {
  var label = i18n.t('constant.null');

  if (row) {
    var _loadsh = require("lodash");
    let funcs = _loadsh.concat(row.funcs, row.freeFunctions)
    if (funcs.length > 0) {

      label = "";
      for (let temp of funcs) {
        if (temp) {
          label += i18n.t("order.function.map")[temp] + "、";
        }
      }
    }


    label = label.substring(0, label.length - 1);
  }
  return label;
}

export function filterOrderFuncs(funcs=[]) {

  var label = i18n.t('constant.null');
    if (funcs.length > 0) {
      label = "";
      if (typeof(funcs) == 'string'){
        funcs = funcs.split(',');
      }

      for (let temp of funcs) {
        if (temp) {
          label += i18n.t("order.function.map")[temp] + "、";
        }
      }
    label = label.substring(0, label.length - 1);
  }
  return label;
}



// WEBPACK FOOTER //
// ./src/filters/index.js